export default {
  computed: {
    dateFormats () {
      return [
        'D.M.YYYY',
        'M.D.YYYY',
        'YYYY.MM.DD',
        'DD-MM-YYYY',
        'MM-DD-YYYY',
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'YYYY/MM/DD'
      ]
    },
    timeFormats () {
      return [
        'H.mm',
        'H:mm',
        'h:mm A'
      ]
    },
    numberFormats () {
      return [
        'fi-FI',
        'en-US'
      ]
    },
    numberLocale () {
      return this.settings?.numberformat?.split('-')[0] || 'fi'
    }
  },
  methods: {
    formatNumber (num, format, digits = 2) {
      return Intl.NumberFormat(format, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(num)
    },
    formatVat (num, format) {
      if (parseInt(num, 10) != parseFloat(num)) {
        return this.formatNumber(num, format, 1)
      }
      return num
    }
  }
}